<template>
  <MakerCartGuideLayout
    pageTitle="Purposeful Maker Mindset"
    heroImage="/images/maker-cart-guide/teacher-presenting.png"
    nextUrl="/makercart/guide/2"
    :showWelcome="true"
  >
    <!-- Growth Mindset Section -->
    <div class="x-section">
      <img
        src="/images/maker-cart-guide/growth-mindset.svg"
        width="50px"
        alt="Growth Mindset"
      />
      <div class="x-section-content">
        <h2 class="x-section-title">Growth Mindset</h2>
        <div class="x-section-body">
          <p>A Maker is someone who believes they can learn to do anything.</p>
          <p>
            Having a Growth Mindset (as opposed to a fixed mindset), is a self
            belief and confidence that you can learn whatever you want to learn.
            When we encourage growth mindset, students view errors as an
            opportunity to learn and grow instead of being fixated on the
            'failure'. We are more concerned about "how they are learning" (the
            process) instead of "what they have learnt" (the outcome).
          </p>
        </div>
      </div>
    </div>

    <!-- Craftsmanship Section -->
    <div class="x-section">
      <img
        src="/images/maker-cart-guide/origami.svg"
        width="50px"
        alt="Craftsmanship"
      />
      <div class="x-section-content">
        <h2 class="x-section-title">Craftsmanship</h2>
        <div class="x-section-body">
          <p>
            A Maker is someone who has excellent work ethic and maintains the
            highest standards for themselves even when no one is looking.
          </p>
          <p>
            With a mindset of Craftsmanship, we believe that there are multiple
            pathways to success and success should be self-defined. When
            students ask "Is this good enough?", we turn the question around
            with "Is this good enough for you?".
          </p>
          <p>
            Having Craftsmanship also means that the students are constantly
            improving themselves (not because they are competing with other
            people). This means excellent work ethics, and could be seen through
            the quality of work and how they take initiative to keep their
            workstations clean.
          </p>
        </div>
      </div>
    </div>

    <!-- Open Sharing Section -->
    <div class="x-section">
      <img
        src="/images/maker-cart-guide/lotus.svg"
        width="50px"
        alt="Open Sharing"
      />
      <div class="x-section-content">
        <h2 class="x-section-title">Open Sharing</h2>
        <div class="x-section-body">
          <p>
            A Maker is someone who is willing to share their ideas and build
            upon the idea of others to achieve collective brilliance.
          </p>
          <p>
            We would like to make a distinction between a Maker and a DIY
            enthusiast. In our definition, a DIY enthusiast most often make for
            the sake of individualistic pursuit. On the other hand, a Maker is
            someone who believes in "winning together".
          </p>
          <p>
            To create a conducive environment for open sharing, in the former
            case, the question is how the teacher step in when they observe
            "judging", and how they can encourage everyone to "listen kindly".
            In the latter, it is how we teach the students to give credit to the
            people who have assisted them and how we encourage them to build
            upon each other's ideas such that they multiply in value.
          </p>
        </div>
      </div>
    </div>
  </MakerCartGuideLayout>
</template>

<script setup>
import MakerCartGuideLayout from "@/components/maker-cart/MakerCartGuideLayout.vue";
</script>

<style scoped></style>
